export class PromoCodeUsageLimitExceededError extends Error {
    constructor() {
        super('ERROR_PROMOCODE_USAGE_LIMIT_EXCEEDED');
    }
}
